import { defineComponent, ref, getCurrentInstance, SetupContext, computed, PropType } from 'vue';
import Toast from 'vant/lib/toast';
import Cookies from 'js-cookie';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import { formateNum, copyToClipboard } from '@/common/utils';
import { Feed, FeedLiked, UserComment, FeedApiService, AuthorFollowing } from '@/api/feed';
import { sendLog } from '@/common/radar';
import { getLlsidFromExptag } from '@/common/common-params';
import { VideoRef } from '../../../type';
import { FeedPageEnum } from '@/store/modules/feed';
import { UserInfoByLogin } from '@/api/user';
import { IconMap, ActionItem, ActionType, ActionBarProps } from './common';

export const ActionBarSeoSetup = (props: ActionBarProps, ctx: SetupContext<Array<'onChangeLoginPopupVisible'>>) => {
    const FeedApi = new FeedApiService();
    const { proxy } = getCurrentInstance() || {};

    const feedList = computed<Feed[]>(() => {
        const { feedListOrigin } = proxy?.$store?.state?.feedMoudle || {};
        return feedListOrigin?.[props?.feedPage || FeedPageEnum.PwaShareNew] || [];
    });

    const handleLikeAction = debounce(async (type: ActionType) => {
        const feedLikeStatus = type === ActionType.Like ? FeedLiked.Like : FeedLiked.UnLike;
        const res = await FeedApi.changeFeedLikedStatus(
            {
                cancel: feedLikeStatus === FeedLiked.UnLike,
                photoId: props?.photoId,
            },
            {
                params: {
                    'kwaipro.pwa_ph': Cookies.get('kwaipro.pwa_ph'),
                },
            }
        );

        if (res?.result !== 1) {
            if (res?.result === 109) {
                // eslint-disable-next-line vue/require-explicit-emits
                ctx.emit('onChangeLoginPopupVisible', true);
                return;
            }

            res?.error_msg &&
                Toast({
                    message: res?.error_msg,
                });
            return;
        }

        const newFeedList = feedList.value?.map?.(feed => {
            if (feed.photo_id_str === props?.photoId) {
                return {
                    ...feed,
                    liked: feedLikeStatus,
                };
            }
            return feed;
        });
        proxy?.$store?.commit?.('feedMoudle/resetFeedList', props.feedPage);
        proxy?.$store?.commit?.('feedMoudle/setFeedList', {
            [props?.feedPage || FeedPageEnum.PwaShareNew]: newFeedList || [],
        });
    }, 300);

    return {
        handleLikeAction,
    };
};
